import { ClaimsToRoleType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES_ADD_CLAIMS } from "../../utils/constants";

export const addClaimsToRole = async (data: ClaimsToRoleType) => await post<ClaimsToRoleType, string>(ROLES_ADD_CLAIMS, data);